Ext.define('SA.view.ImportFileListItem', {
    alias: 'widget.import-file-list-item',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-import-file-list-item',
    removable: true,

    items: [
        {
            xtype: 'file-input',
            itemId: 'fileInput'
        }, {
            xtype: 'combo-button',
            cls: 'sa-import-file-list-item-geographic-unit-dropdown',
            emptyText: 'Geographic Unit',
            itemId: 'geographicUnitDropDown',
            textField: 'name',
            valueField: 'id',
            width: 145
        }, {
            xtype: 'remove-button',
            autoEl: {tag: 'button'},
            cls: 'sa-import-file-list-item-remove-btn',
            itemId: 'removeBtn'
        }
    ],

    initComponent() {
        this.callParent();

        this.fileInput = this.down('#fileInput');
        this.geographicUnitDropDown = this.down('#geographicUnitDropDown');
        this.removeBtn = this.down('#removeBtn');

        this.setGeographicUnits(this.geographicUnits);
        this.setRemovable(this.removable);
    },

    async getValue() {
        var file = this.fileInput.getFile(),
            unit = this.geographicUnitDropDown.getValue(),
            parseCsv = () => SA.model.createimport.File.fromCSV(file);

        if (!file && !unit) {
            return null;
        }

        return new SA.model.createimport.FileTuple({file: await parseCsv(), unit});
    },

    initEvents() {
        this.callParent();

        this.removeBtn.on('click', this.onRemoveBtnClick, this);
    },

    onRemoveBtnClick() {
        this.fireEvent('click:remove', this);
    },

    setGeographicUnits(geographicUnits) {
        this.geographicUnitDropDown.setItems(geographicUnits);
        this.geographicUnitDropDown.setValue(null);
    },

    setRemovable(removable) {
        this.removeBtn.ifCls(removable, 'sa-import-file-list-item-remove-btn-enabled');
    }
});
